//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import Filters from './StatisticsRequisitesFilters.vue';
import constant from '~/const';
import Pagination from '~/components/Pagination.vue';

import tableConfig from './tableConfig';

export default {
  components: { Filters, Pagination },

  data() {
    return {
      tableConfig,
      constant,
      selection: [],
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('statisticsRequisites', ['data', 'page', 'pages']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('statisticsRequisites', {
      loadDataAction: 'loadData',
      setPageAction: 'setPage',
    }),
    ...mapActions('tradersRequisites', {
      loadRequisites: 'loadData',
    }),

    async applyFilters() {
      try {
        this.setGeneralLoader(true);
        await this.loadDataAction();
        this.setGeneralLoader(false);
      } catch (error) {
        this.setErrorNotification(error.message);
      }
    },

    setPage(value) {
      this.setPageAction(value);
      this.loadDataAction();
    },
  },
};
